import React from "react";
import { Link } from "react-router-dom";
import innerBanner from '../../public/assets/images/bg/inner-banner.png';

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

function Breadcrumb({ banner, pageName, pageTitle, id, image, myRef }) {
  const executeScroll = () => scrollToRef(myRef)
  return (
    <div
      className="inner-banner"
      // style={{
      //   background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),url(${image ? image : innerBanner})`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center"
      // }}
    >
      <div className="container">
      <div className="slider-bg-1" image={banner}>
        {/* <h2
                className="inner-banner-title"
                data-wow-duration="1.5s"
                data-wow-delay=".2s"
              >
                {pageTitle}
              </h2> */}
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-start">
                  <li className="breadcrumb-item">
                    <Link to="/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><path fill="currentColor" d="M18.672 11H17v6c0 .445-.194 1-1 1h-4v-6H8v6H4c-.806 0-1-.555-1-1v-6H1.328c-.598 0-.47-.324-.06-.748L9.292 2.22c.195-.202.451-.302.708-.312c.257.01.513.109.708.312l8.023 8.031c.411.425.539.749-.059.749" /></svg>
                      &nbsp;Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {pageName}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
    </div>
  );
}

export default Breadcrumb;
